import { render, staticRenderFns } from "./purchase-payment-delete-confirmation.vue?vue&type=template&id=5faf2b86&scoped=true&"
import script from "./purchase-payment-delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./purchase-payment-delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./purchase-payment-delete-confirmation.vue?vue&type=style&index=0&id=5faf2b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf2b86",
  null
  
)

export default component.exports